import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem} from 'platform/foundation';

import {ArticleUpdateJobSource} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromCustomersAsSupplier, useGetSupplierCustomersQuery} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';

interface BasicInformationFormProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  source: ArticleUpdateJobSource | Nullish;
}

export function BasicInformationForm(props: BasicInformationFormProps) {
  const suppliersQuery = useGetSupplierCustomersQuery();

  return (
    <Grid columns={3} spacing={4}>
      <GridItem span={1}>
        <FormField
          isRequired
          isDisabled={props.source === 'INTEGRATION'}
          isLoading={suppliersQuery.isLoading}
          isNotClearable
          control={props.control}
          type="choice"
          name="basicInformation.supplierId"
          label={i18n.t('entity.warehouse.labels.supplierPriceList')}
          options={getOptionsFromCustomersAsSupplier(suppliersQuery.data)}
          data-testid={suffixTestId('inputs.supplier', props)}
        />
      </GridItem>
      <GridItem span={1}>
        <FormField
          isDisabled
          control={props.control}
          type="date"
          name="basicInformation.publishedAt"
          label={i18n.t('general.labels.publishedDate')}
          data-testid={suffixTestId('inputs.publishedAt', props)}
        />
      </GridItem>
      <GridItem span={3}>
        <FormField
          control={props.control}
          type="textarea"
          name="basicInformation.note"
          label={i18n.t('general.labels.note')}
          data-testid={suffixTestId('inputs.note', props)}
        />
      </GridItem>
    </Grid>
  );
}
